// 每日灵修箴言精选库 (中英双语，带跳转出处与章节定位)

export const DAILY_VERSES = [
  {
    chapterId: "43-3",
    verse: 16,
    bookZh: "约翰福音",
    bookEn: "John",
    refZh: "约翰福音 3:16",
    refEn: "John 3:16",
    textZh: "神爱世人，甚至将他的独生子赐给他们，叫一切信他的，不至灭亡，反得永生。",
    textEn:
      "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.",
  },
  {
    chapterId: "19-23",
    verse: 1,
    bookZh: "诗篇",
    bookEn: "Psalms",
    refZh: "诗篇 23:1",
    refEn: "Psalms 23:1",
    textZh: "耶和华是我的牧者，我必不至缺乏。",
    textEn: "The LORD is my shepherd; I shall not want.",
  },
  {
    chapterId: "50-4",
    verse: 13,
    bookZh: "腓利比书",
    bookEn: "Philippians",
    refZh: "腓立比书 4:13",
    refEn: "Philippians 4:13",
    textZh: "我靠着那加给我力量的，凡事都能做。",
    textEn: "I can do all things through Christ which strengtheneth me.",
  },
  {
    chapterId: "20-3",
    verse: 5,
    bookZh: "箴言",
    bookEn: "Proverbs",
    refZh: "箴言 3:5-6",
    refEn: "Proverbs 3:5-6",
    textZh:
      "你要专心仰赖耶和华，不可倚靠自己的聪明，在你一切所行的事上都要认定他，他必指引你的路。",
    textEn:
      "Trust in the LORD with all thine heart; and lean not unto thine own understanding. In all thy ways acknowledge him, and he shall direct thy paths.",
  },
  {
    chapterId: "23-40",
    verse: 31,
    bookZh: "以赛亚书",
    bookEn: "Isaiah",
    refZh: "以赛亚书 40:31",
    refEn: "Isaiah 40:31",
    textZh:
      "但那等候耶和华的必从新得力。他们必如鹰展翅上腾；他们奔跑却不困倦，行走却不疲乏。",
    textEn:
      "But they that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.",
  },
  {
    chapterId: "45-8",
    verse: 28,
    bookZh: "罗马书",
    bookEn: "Romans",
    refZh: "罗马书 8:28",
    refEn: "Romans 8:28",
    textZh:
      "我们晓得万事都互相效力，叫爱神的人得益处，就是按他旨意被召的人。",
    textEn:
      "And we know that all things work together for good to them that love God, to them who are the called according to his purpose.",
  },
  {
    chapterId: "40-6",
    verse: 33,
    bookZh: "马太福音",
    bookEn: "Matthew",
    refZh: "马太福音 6:33",
    refEn: "Matthew 6:33",
    textZh: "你们要先求他的国和他的义，这些东西都要加给你们了。",
    textEn:
      "But seek ye first the kingdom of God, and his righteousness; and all these things shall be added unto you.",
  },
  {
    chapterId: "6-1",
    verse: 9,
    bookZh: "约书亚记",
    bookEn: "Joshua",
    refZh: "约书亚记 1:9",
    refEn: "Joshua 1:9",
    textZh:
      "我岂没有吩咐你吗？你当刚强壮胆！不要惧怕，也不要惊惶；因为你无论往哪里去，耶和华你的神必与你同在。",
    textEn:
      "Have not I commanded thee? Be strong and of a good courage; be not afraid, neither be thou dismayed: for the LORD thy God is with thee whithersoever thou goest.",
  },
  {
    chapterId: "24-29",
    verse: 11,
    bookZh: "耶利米书",
    bookEn: "Jeremiah",
    refZh: "耶利米书 29:11",
    refEn: "Jeremiah 29:11",
    textZh:
      "耶和华说：我知道我向你们所怀的意念是赐平安的意念，不是降灾祸的意念，要叫你们末后有指望。",
    textEn:
      "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end.",
  },
  {
    chapterId: "19-119",
    verse: 105,
    bookZh: "诗篇",
    bookEn: "Psalms",
    refZh: "诗篇 119:105",
    refEn: "Psalms 119:105",
    textZh: "你的话是我脚前的灯，是我路上的光。",
    textEn: "Thy word is a lamp unto my feet, and a light unto my path.",
  },
  {
    chapterId: "48-5",
    verse: 22,
    bookZh: "加拉太书",
    bookEn: "Galatians",
    refZh: "加拉太书 5:22-23",
    refEn: "Galatians 5:22-23",
    textZh:
      "圣灵所结的果子，就是仁爱、喜乐、和平、忍耐、恩慈、良善、信实、温柔、节制。",
    textEn:
      "But the fruit of the Spirit is love, joy, peace, longsuffering, gentleness, goodness, faith, meekness, temperance.",
  },
  {
    chapterId: "55-1",
    verse: 7,
    bookZh: "提摩太后书",
    bookEn: "2 Timothy",
    refZh: "提摩太后书 1:7",
    refEn: "2 Timothy 1:7",
    textZh: "因为神赐给我们，不是胆怯的心，乃是刚强、仁爱、谨守的心。",
    textEn:
      "For God hath not given us the spirit of fear; but of power, and of love, and of a sound mind.",
  },
  {
    chapterId: "19-46",
    verse: 1,
    bookZh: "诗篇",
    bookEn: "Psalms",
    refZh: "诗篇 46:1",
    refEn: "Psalms 46:1",
    textZh: "神是我们的避难所，是我们的力量，是我们在患难中随时的帮助。",
    textEn:
      "God is our refuge and strength, a very present help in trouble.",
  },
  {
    chapterId: "45-12",
    verse: 2,
    bookZh: "罗马书",
    bookEn: "Romans",
    refZh: "罗马书 12:2",
    refEn: "Romans 12:2",
    textZh:
      "不要效法这个世界，只要心意更新而变化，叫你们察验何为神的善良、纯全、可喜悦的旨意。",
    textEn:
      "And be not conformed to this world: but be ye transformed by the renewing of your mind, that ye may prove what is that good, and acceptable, and perfect, will of God.",
  },
];

export const getDailyVerse = (offset = 0) => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);

  const index = (dayOfYear + offset) % DAILY_VERSES.length;
  const safeIndex = (index + DAILY_VERSES.length) % DAILY_VERSES.length;
  return DAILY_VERSES[safeIndex];
};
